import { ReactNode } from "react";

interface StudentProfileCardProps {
    title?: string;
    children: ReactNode;
    cardStyling?: string; // robust styling, to insert into className of card
}

export const StudentProfileCard: React.FC<StudentProfileCardProps> = ({title, children, cardStyling}) => {
    return (
        <div className={`w-full shadow-[0_0px_15px_rgba(0,0,0,0.1)] dark:shadow-[0_0px_10px_rgba(0,0,0,0.25)] rounded-3xl m-0 p-8 ${cardStyling ?? ""}`}>
            <h2 className="font-semibold mb-4">{title}</h2>
            {children}
        </div>
    )
}